// extracted by mini-css-extract-plugin
export default {"AddonsList__containerHeading":"AddonsList_AddonsList__containerHeading__l-6nx"};